import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import fr from './locales/fr.json';
import en from './locales/en.json';

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            fr: { translation: fr },
            en: { translation: en },
        },
        fallbackLng: 'fr',
        supportedLngs: ['fr', 'en'],
        // localStorage must be checked before navigator, otherwise a manual
        // language switch never survives a reload -- the detector re-derives
        // from the browser on every init regardless of what's cached ("caches"
        // only controls where a choice is written, not read priority).
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18next;
